import type { ReactNode } from 'react';

import { cn } from '@/shared/lib/cn';

/** Spin animation that falls back to a gentle pulse when prefers-reduced-motion is set. */
export const portalSpinClass =
  'animate-spin motion-reduce:animate-pulse motion-reduce:border-t-primary/70';

const spinnerSizeClass = {
  sm: 'h-8 w-8',
  md: 'h-9 w-9',
} as const;

type PortalSpinnerSize = keyof typeof spinnerSizeClass;

interface PortalLoadingSpinnerProps {
  size?: PortalSpinnerSize;
  className?: string;
}

export function PortalLoadingSpinner({ size = 'sm', className }: PortalLoadingSpinnerProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'rounded-full border-2 border-primary border-t-transparent',
        portalSpinClass,
        spinnerSizeClass[size],
        className,
      )}
    />
  );
}

interface PortalLoadingStateProps {
  size?: PortalSpinnerSize;
  message: ReactNode;
  className?: string;
}

export function PortalLoadingState({ size = 'sm', message, className }: PortalLoadingStateProps) {
  return (
    <div role="status" className={cn('flex flex-col items-center gap-3', className)}>
      <PortalLoadingSpinner size={size} />
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
